import './_rollupPluginBabelHelpers-a38db067.js';
import './styled-system/utils.js';
import './styled-system/core/core-utils.js';
import './styled-system/core/parser.js';
import './styled-system/core/compose.js';
import './styled-system/core/style-function.js';
import './styled-system/core/system.js';
import './styled-system/parsers/typography.js';
import './styled-system/parsers/transition.js';
import './styled-system/parsers/margin.js';
import './styled-system/parsers/padding.js';
import './styled-system/parsers/space.js';
import './styled-system/parsers/shadow.js';
import './styled-system/parsers/animation.js';
import './styled-system/parsers/background.js';
import './styled-system/parsers/border.js';
import './styled-system/parsers/color.js';
import './styled-system/parsers/flexbox.js';
import './styled-system/parsers/grid.js';
import './styled-system/parsers/layout.js';
import './styled-system/parsers/other.js';
import './styled-system/parsers/position.js';
import { parsers } from './styled-system/parsers/parsers-config.js';
import { pseudo } from './styled-system/parsers/pseudo.js';
import './styled-system/css/css-utils.js';
import './styled-system/css/index.js';
import scStyled, { css } from 'styled-components';

const getCreateStyle = (baseCreateStyle, parsers) => {
  const createStyle = (...args) => baseCreateStyle(parsers, pseudo, css(...args));
  createStyle.attrs = attrs => {
    const attrsCreateStyle = baseCreateStyle.attrs(attrs);
    return getCreateStyle(attrsCreateStyle, parsers);
  };
  createStyle.withConfig = config => getCreateStyle(baseCreateStyle.withConfig(config), parsers);
  return createStyle;
};
const string = n => typeof n === 'string' && n !== '';
const createShouldForwardProp = parsers => {
  const propSet = new Set(parsers.propNames);
  return (prop, defaultValidatorFn, elementToBeCreated) => {
    if (string(prop) && propSet.has(prop)) {
      return false;
    }
    if (typeof elementToBeCreated === 'string') {
      // We must test elementToBeCreated so we can pass through props for <x.div
      // as={Component} />. However elementToBeCreated isn't available until
      // styled-components 5.2.4 or 6, and in the meantime will be undefined.
      // This means that HTML elements could get unwanted props, but ultimately
      // this is a bug in the caller, because why are they passing unwanted
      // props?
      return defaultValidatorFn(prop);
    }
    return true;
  };
};

/**
 * Creates a styled interface that supports theming using the provided parser.
 *
 * @param parsers - The parser used to generate styles.
 * @returns A styled interface compatible with theming.
 */
const createBaseStyled = parsers => {
  const config = parsers ? {
    shouldForwardProp: createShouldForwardProp(parsers)
  } : {};
  return component => {
    const baseStyled = scStyled(component);
    return getCreateStyle(config ? baseStyled.withConfig(config) : baseStyled, parsers);
  };
};
const createStyled = parsers => {
  const styled = createBaseStyled(parsers);
  Object.keys(scStyled).forEach(key => {
    // @ts-ignore
    styled[key] = styled(key);
  });
  return styled;
};
const styled = createStyled(parsers);

export { createBaseStyled, string, styled };
